/**
 * @module app.cm
 */

import { DynamicViews } from 'app/shared/config/modules';
import { PLATFORM } from 'aurelia-pal';

export function getCaseManagementTaskTypes(): DynamicViews {
    return {
        'CM.Case': [
            {
                title: 'cm:taskTypes.case.$title',
                url: PLATFORM.moduleName('app/cm/components/tasks/smart-case'),
                icon: 'cm:icons.carePlan'
            }
        ],
        'CM.Service': [
            {
                title: 'cm:taskTypes.service.$title',
                url: PLATFORM.moduleName('app/cm/components/tasks/smart-service'),
                icon: 'ui:icons.diagnoses'
            }
        ]
    };
}

export function getCaseManagementTaskFollowups(): DynamicViews {
    return {
        'CM.CarePlanIntervention': [
            {
                title: 'cm:taskTypes.followups.intervention.$title',
                url: PLATFORM.moduleName('app/cm/components/common/task-followups')
            }
        ],
        'CM.CaseTask': [
            {
                title: 'cm:taskTypes.followups.intervention.$title',
                url: PLATFORM.moduleName('app/cm/components/common/task-followups')
            }
        ]
    };
}
